<template>
    <div>
        <delete-i-b-modal v-if="showModal"
            @confirm="onIntermediaryBusinessDeletion"
            @cancel="showModal = false"
            ref="intermediaryDeletionModal"
        ></delete-i-b-modal>
        <div class="title">
            <h3 class="left">Apporteur d'affaires</h3>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <div v-if="!forms.association">
                    {{ intermediaryBusinessName }}

                    <button v-if="hasIntermediaryBusiness" 
                            class="btn btn-default btn-sm pull-right"
                            @click="showModal = true">Supprimer</button>
                    <button v-else 
                            @click="forms.association = true" 
                            class="btn btn-default btn-sm pull-right">Associer</button>
                </div>
                <div v-else>
                    <div class="form-group">
                        <label>Recherche apporteur d'affaires</label>
                        <search-and-select :initial-value="selectedIntermediaryBusiness"
                            :search-config="intermediaryBusinessSearchConfig"
                            :get-option-label="getIntermediaryBusinessSearchLabel"
                            :min-chars="3"
                            @field-updated="updateIntermediaryBusiness">
                        </search-and-select>
                    </div>
                    <div class="buttons-container">
                        <button v-if="selectedIntermediaryBusiness" 
                                class="btn btn-sm"
                                @click="onAssociation">Associer</button>
                        <button class="btn btn-sm btn-danger" 
                                @click="onCancelAssociation">Annuler</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.buttons-container {
    margin-top: 10px;

    .btn { 
        margin-right: 5px; 

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>

<script type="text/babel">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import DeleteIBModal from './DeleteIBModal'
    import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"

    import searchMixin from 'mixins/search'

    export default {
        components: {
            DeleteIBModal,
            SearchAndSelect
        },

        mixins: [searchMixin],

        data () {
            return {
                showModal: false,
                forms: {
                    association: false
                },
                intermediaryBusinessOptions: [],
                selectedIntermediaryBusiness: null
            }
        },

        props: {
            model: {
                type: Object,
                default: {}
            }
        },

        computed: {
            hasIntermediaryBusiness() {
                return Object.keys(this.model).length > 0 ? true : false
            },

            intermediaryBusinessName() {
                let name = this.hasIntermediaryBusiness ? this.model.name : 'Aucun'

                if ( this.model.erp_id )
                    name += ' (' + this.model.erp_id + ')'

                return name
            }
        },

        methods: {
            ...mapActions('customer', [
                'removeIntermediaryBusiness',
                'addIntermediaryBusiness',
                'fetchCustomer',
            ]),

            resetFields() {
                this.selectedIntermediaryBusiness = null
            },

            updateIntermediaryBusiness(event)
            {
                this.selectedIntermediaryBusiness = event
            },

            searchIntermediaryBusinesses: _.debounce((loading, search, vm) => {
                let params = {
                    search,
                    paginate: 0,
                    with:"address"
                }

                return (vm.axios.get('intermediary_business', {params})
                .then((response) => {
                    vm.componentOptions = response.data.intermediary_businesses
                    loading(false)
                })
            )}, 350),

            onAssociation() {
                this.addIntermediaryBusiness(this.selectedIntermediaryBusiness)
                    .then(() => this.onCancelAssociation())
            },

            onCancelAssociation() {
                this.resetFields()
                this.forms.association = false
            },

            onIntermediaryBusinessDeletion() {
                const vm = this

                this.removeIntermediaryBusiness()
                    .then(function () {
                        vm.refreshCustomer()
                        vm.showModal = false
                    })
                    .catch(function (error) {
                        const message = error.hasOwnProperty('response') && error.response.hasOwnProperty('data') && error.response.data.hasOwnProperty('message')
                            ? error.response.data.message
                            : "Une erreur s'est produite, merci de réessayer"

                        vm.$refs.intermediaryDeletionModal.errorMessage = message
                    })
            },

            refreshCustomer() {
                this.fetchCustomer(this.$route.params.id)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/IntermediaryBusiness.vue